import React, { Component } from "react";
import actions from "@/redux/action";
import { connect } from "react-redux";

import CropPicFunction from "./children/CropPicFunction";

class CropPic extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <CropPicFunction
        work={this.props.work}
        handleCropSubmit={this.props.handleCropSubmit}
        onCropChange={this.props.onCropChange}
        onCropModalClose={() => {
          this.props.onCropChange(null);
          this.props.onCurrFileChange(null);
        }}
        crop={this.props.crop}
        currFile={this.props.currFile}
      />
    );
  }
}

const mapStateToPropos = state => ({
  tokenId: state.common.tokenId,
  currFile: state.files.currFile,
  crop: state.work.crop,
});

const mapDispatchToProps = dispatch => ({
  onCropChange: crop => dispatch(actions.onCropChange(crop)),
  onCurrFileChange: currFile => dispatch(actions.onCurrFileChange(currFile)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(CropPic);
